export default {
    /**
     * update sessionOrder object in store
     * @param state
     * @param sessionOrder
     */
    updateSessionOrder(state, sessionOrder) {
        //server session order should not be mutate locally
        state.sessionOrder = sessionOrder;
    },
    updateEditingOrderItemId(state, editingOrderItemId) {
        state.editingOrderItemId = editingOrderItemId;
    }
};